<template>
    <div class="card shadow-sm mb-5 p-5 card-flush overflow-hidden h-md-100">
      <button v-if="remove"
          type="button"
          class="btn-close position-absolute top-0 end-0 mt-2 me-4"
          aria-label="Remove"
          @click="remove"/>
          
        <div class="card-header">
          <div class="card-title">
              <h5 style="text-align: start">{{ title }}</h5>
          </div>
            
        </div>
        <Loader :is-loading="loading">
          <div class="card-body d-flex text-center justify-content-center flex-column px-0">
            <div v-show="!saleEstimates?.length" class="text-center">
              <img src="@/assets/media/pos/Empty2.png" alt="" class="mw-100 h-150px" />
              <div class="text-gray-400 fs-4 fw-bold">{{ $t('no_data_found') }}</div>
            </div>
            <div v-show="saleEstimates?.length" class="p-5">
              <canvas id="kt_chartjs_estimate" class="mh-200px"></canvas>
            </div>
          </div>
        </Loader>
    </div>  
</template>
<script setup>
import Loader from '@/components/Loader.vue';
import {  shallowRef,onMounted, ref, watch} from 'vue';
import { useStore } from 'vuex';

const store = useStore()

const props = defineProps({
  id:{type: String, required: true},
  title:{type: String, required: true},
  loading:{type: Boolean, default: false},
  loadStats:{type: Function, required: true},
  remove:{type: Function},
  start: { type: Date, required: false },
  end: { type: Date, required: false },
})
  
const query = ref({
    start_date: '',
    end_date: '',
    opportunity_id: '',
    seller_id: '',
    status: 'WON'
})


const saleEstimates = ref([])
const chartEstimateRef = shallowRef(null)

watch(() => [props.start, props.end], () => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})

watch(() => query.value, () => {
  if (query.value.start_date && query.value.end_date) {
    loadData();
  }
}, {deep: true})


function loadData(){
  if (!query.value.start_date || !query.value.end_date) {
    console.warn("Dates non définies, loadData ignorée");
    return;
  }
  
    Promise.all([
        props.loadStats({id:props.id,startDate: query.value.start_date, endDate: query.value.end_date, opportunity_id: query.value.opportunity_id, seller_id: query.value.seller_id, status: query.value.status}).then((res) => {
          saleEstimates.value = res?.data?.estimate_sales_by_period || res?.response?.estimate_sales_by_period

        }),
       
    ]).then(() => {
      chartEstimate()
    })
}

function chartEstimate(){
    let monthlyData = [];
    let monthlyLabels = [];
  
    saleEstimates.value?.forEach(estimate => {
        if(estimate.value != 0){
          monthlyData.push(estimate.value)
          monthlyLabels.push(estimate.date)
        } 
    })
  
    if(monthlyData.length <= 0){
      saleEstimates.value = []
    }
    
    let ctx = document.getElementById('kt_chartjs_estimate');
   
    if (ctx) {
      if(Chart.getChart("kt_chartjs_estimate")) {
        Chart.getChart("kt_chartjs_estimate")?.destroy()
      }

      let context = ctx.getContext('2d');
      let data = {
        labels: monthlyLabels,
        datasets: [{
            label: 'Earnings',
            data: monthlyData,
            fill: true,
            borderColor: 'rgba(75, 192, 192, 1)',
            backgroundColor: 'rgba(75, 192, 192, 0.2)',
            tension: 0.4,
        }]
      };
  
      let config = {
          type: 'line',
          data: data,
          options: {
            responsive: true,
            plugins: {
              legend: {
                  display: false
              },
              tooltip: {
                  callbacks: {
                      label: function(context) {
                          return `${i18n.global.t('statistics.amount')}: ${$formatLocalAmount(context.parsed.y)} ${defaultCurrency.value?.symbol}`;
                      }
                  }
              }
            }
          }
      };
  
      if (!chartEstimateRef.value) {
        chartEstimateRef.value = new Chart(ctx, config);
      }else{
        chartEstimateRef.value.destroy()
        chartEstimateRef.value = new Chart(ctx, config);
      }
    } else {
      console.error('Canvas element not found');
      return;
    }
    
  }

  
onMounted(() => {
 if(props.start) query.value.start_date = props.start
 if(props.end) query.value.end_date = props.end
})
</script>